import React, {memo} from "react";
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import NotificationActions from "../../redux/Notification/actions";
import {useDispatch} from "react-redux";
import {push} from 'connected-react-router';
import {IconFont} from "../IconFont";
import {NotificationType} from "../../enums/NotificationType";

dayjs.extend(relativeTime);

const {
    openModal,
    closeDropdown,
    setAsReadNotification,
} = NotificationActions;

function ListItem(props) {
    const { item } = props;

    const {
        content_type: contentType,
        created_at: createdAt,
        is_read: isRead,
        subtitle,
        title,
        url,
    } = item || {};

    const dispatch = useDispatch();

    const onRowClick = () => {
        dispatch(setAsReadNotification());

        // Do nothing
        if (contentType === NotificationType.none)
            return null;

        // Navigate to URL
        if (contentType === NotificationType.link) {
            if (url.startsWith('/'))
                dispatch(push(url));
            else
                window.open(url, '_blank');
            return dispatch(closeDropdown());
        }

        // Open Modal
        dispatch(openModal(item, true));
        return null;
    };

    // const readClassName = `list-item-content-read-button${item.is_read ? ' read' : ' not-read'}`
    const clickableClassName = contentType !== NotificationType.none ? 'clickable' : '';
    const className = `list-item-container ${isRead ? 'read' : 'unread'} ${clickableClassName}`;

    return (
        <div className={className} onClick={onRowClick}>
            <div className="list-item-avatar">
                <div className="icon" />
            </div>
            <div className="list-item-content-container">
                <div className="list-item-content-title">
                    { title }
                </div>
                <div className="list-item-content-subtitle">
                    { subtitle }
                </div>
                <div className="list-item-content-time-elapsed">
                    {dayjs(createdAt).fromNow()}
                </div>
            </div>
            <div className="list-item-read-col">
                {
                    ![
                        NotificationType.none,
                        NotificationType.text,
                        NotificationType.table,
                    ].includes(contentType) &&
                        <IconFont type="icon-new-tab" className="new-tab-icon" />
                }
            </div>
            {/*    /!*<Tooltip placement='top' title={data.isRead? "Set as Unread" : "Set as Read"}>*!/*/}
            {/*    <div className={readClassName} />*/}
            {/*    /!*</Tooltip>*!/*/}
            {/*    <div className="list-item-content-clear-button" style={{ display: 'none'}}>*/}
            {/*        <Button*/}
            {/*            shape="circle"*/}
            {/*            icon={<DeleteOutlined />}*/}
            {/*            danger*/}
            {/*            size={12}*/}
            {/*        />*/}
            {/*    </div>*/}
            {/*</div>*/}
        </div>
    );
}

export default memo(ListItem);
